/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_LoadInputs */

const en_us2_workout_load = /** @type {(inputs: Workout_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load`)
};

const pt_br2_workout_load = /** @type {(inputs: Workout_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carga`)
};

const es_419_workout_load = /** @type {(inputs: Workout_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carga`)
};

const pt_pt2_workout_load = /** @type {(inputs: Workout_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carga`)
};

const fr_fr2_workout_load = /** @type {(inputs: Workout_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charge`)
};

const de_de2_workout_load = /** @type {(inputs: Workout_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewicht`)
};

const it_it2_workout_load = /** @type {(inputs: Workout_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carico`)
};

/**
* | output |
* | --- |
* | "Load" |
*
* @param {Workout_LoadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_load = /** @type {((inputs?: Workout_LoadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_LoadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_load(inputs)
	if (locale === "es-419") return es_419_workout_load(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_load(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_load(inputs)
	if (locale === "de-DE") return de_de2_workout_load(inputs)
	if (locale === "it-IT") return it_it2_workout_load(inputs)
	return en_us2_workout_load(inputs)
});
export { workout_load as "workout.load" }